import { Power3, gsap } from 'gsap';

export const positionAnimation = (ref: HTMLDivElement, position: number) => {
  gsap.to(ref, {
    x: position, // Jarak slide horizontal
    duration: 0.5, // Durasi animasi dalam detik
    ease: Power3.easeIn // Efek animasi
  });
};
